// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"bb95157b","916":"d6c23827"}[chunkId] + ".chunk.js";
};